// extracted by mini-css-extract-plugin
module.exports = {"productDetailWrapper":"Overview_productDetailWrapper__OwC67","theme_white":"Overview_theme_white__eBtlB","theme_black":"Overview_theme_black__SSQfd"};